<div class="session-details-panel">
    <p-dialog header="Session Details" [(visible)]="isSessionDetailsModelOpen" [modal]="true" [draggable]="false"
        [style]="{ width: '90vw','margin-left': '1em' }" [closeOnEscape]="false" (onHide)="closeSessionDetailsModal()">
        <app-panel-list [showLoader]="showLoader"
            *ngIf="sessionDetailsData != undefined && isSessionDetailsAvailable && !showLoader"
            [panelList]="sessionDetailsData" [noResultFound]="noData" class="session-panel">
            <ng-template #templateRef let-data="dataVar">
                <div panel-content>
                    <div class="grid">
                        <div class="col-5">
                            <app-label labelText="{{ 'Date & Time'}}"></app-label>
                            <app-read-only [readonlyText]="setDateTime(data)"></app-read-only>
                        </div>
                        <div class="col-3">
                            <app-label labelText="{{ 'Trainer(s)'}}"></app-label>
                            <div class="overflow-ellipsis">
                                <div *ngFor="let trainer of data?.trainers">
                                    {{trainer.isactive}}
                                    <app-read-only
                                        [ngClass]="{'inactive':trainer.isActive===false || trainer.isTerminated === true}"
                                        readonlyText="{{ trainer.assignedUserName}}"
                                        toolTipMessage="{{trainer.assignedUserName}}"></app-read-only>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <app-label labelText="{{ 'Format'}}"></app-label>
                            <app-read-only readonlyText="{{data?.format}}"></app-read-only>
                        </div>

                        <div class="col-2">
                            <app-label labelText="{{ 'Attachment(s)'}}"></app-label>
                            <div *ngIf="data?.attachments !==null && data?.attachments.length > 0"
                                class="col max-w-0 pl-1">
                                <em class="pi pi-paperclip blue-color cursor-pointer"
                                    (click)="OpenSessionAttachmentModal(data?.sessionId)">
                                </em>
                            </div>
                            <div *ngIf="data?.attachments === null || data?.attachments.length === 0"
                                class="col max-w-0 pl-1">
                                <app-read-only readonlyText="N/A"></app-read-only>
                            </div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col-5">
                            <app-label labelText="{{ 'Status'}}"></app-label>
                            <div class="grid pt-1 session-status">
                                <div class="col max-w-0 pb-0">
                                    <em class="pi pi-circle-fill mr-1 mt-1"
                                        [ngClass]="calculateStatusColor(data?.status)"></em>
                                </div>
                                <div class="col ml-1 pb-0">
                                    <app-read-only readonlyText="{{data?.status}}"></app-read-only>
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <app-label labelText="{{ 'Enrollment'}}"></app-label>
                            <div class="grid pt-1 session-enrollment">
                                <div class="col max-w-0 pb-0">
                                    <em class="pi pi-circle-fill mr-1 mt-1"
                                        [ngClass]="calculateEnrollmentColor(data?.enrollment)"></em>
                                </div>
                                <div class="col ml-1 pb-0">
                                    <app-read-only readonlyText="{{data?.enrollment}}"></app-read-only>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <app-label labelText="{{ 'Virtual Meeting URL'}}"></app-label>
                            <div *ngIf="data?.virtualMeetingURL!=='N/A'" class="col max-w-0 pl-1">
                                <em
                                        class="pi pi-external-link blue-color cursor-pointer"
                                        (click)="OpenVirtualMeeting(data?.virtualMeetingURL)"></em>
                            </div>
                            <div *ngIf="data?.virtualMeetingURL==='N/A'">
                                <app-read-only readonlyText="N/A"></app-read-only>
                            </div>
                        </div>
                        <div class="col-2">
                            <app-label labelText="{{ 'Room'}}"></app-label>
                            <div class="overflow-ellipsis">
                                <app-read-only readonlyText="{{data?.room}}"
                                    toolTipMessage="{{data?.room}}"></app-read-only>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </app-panel-list>
        <div class="displayCenter" *ngIf="(sessionDetailsData==undefined || !isSessionDetailsAvailable) && !showLoader">
            <app-empty-results></app-empty-results>
        </div>
    </p-dialog>
</div>

<app-attachments-modal *ngIf="showAttachmentsModal" (attachmentsPopupVisible)="closeAttachmentModal($event)"
    [attachmentsData]="sessionAttachments"> </app-attachments-modal>